import moment from 'moment';

export const formatDate = (date: Date) =>
    date?.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

export const formatDateToMMDDYYYY = (dateString?: string): string => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.valueOf())) return '';
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    const localDate = new Date(year, month, day);
    return localDate.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
};

export const formattDateToIso = (dateString?: string): string | null => {
    if (!dateString || dateString.length !== 10) {
        return null;
    }

    const parsed = moment(dateString, 'MM/DD/YYYY', true);

    if (!parsed.isValid()) {
        return null;
    }

    return parsed.format('YYYY-MM-DD');
};

export const formatStringToMmmDdDate = (date: string) => {
    const d = new Date(date);
    return d.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
    });
};

export const formatOrderDate = (dateString: string): string => {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
};
